import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import {
  Autotest,
  Country,
  ErrorPage,
  Home,
  Learn,
  LearnLens,
  LearnRoute,
  LearnTopic,
} from "routes";
import { AppLanguageProvider } from "context/AppLanguageContext";
import { segmentVariants } from "utils/learnPaths";

// Learn's path segments follow the reading language, so every combination is
// registered rather than only the canonical pair: a link shared by a Spanish
// reader has to open for an English one, and every URL that existed before
// the segments were translated has to keep working.
const LEARN = segmentVariants("learn");
const ROUTE = segmentVariants("route");
const LENS = segmentVariants("lens");

const learnRoutePaths = LEARN.flatMap((learn) => [
  { path: `/${learn}`, element: <Learn /> },
  // Three-segment paths are ranked above "/:topicSlug" by the router, so
  // library articles keep their existing URLs.
  ...ROUTE.map((route) => ({
    path: `/${learn}/${route}/:routeSlug`,
    element: <LearnRoute />,
  })),
  ...LENS.map((lens) => ({
    path: `/${learn}/${lens}/:lensSlug`,
    element: <LearnLens />,
  })),
  { path: `/${learn}/:topicSlug`, element: <LearnTopic /> },
]);

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "/countries/:countryName",
      element: <Country />,
    },
    ...learnRoutePaths,
    {
      path: "/autotest",
      element: <Autotest />,
    },
  ].map((route) => ({ ...route, errorElement: <ErrorPage /> }))
);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <AppLanguageProvider>
      <RouterProvider router={router} />
    </AppLanguageProvider>
  </React.StrictMode>
);
